import { Item, MainProduct, Option, Stage } from "@/types/productTypes";
import { ControlHover } from "./MainEditorPanel";
import ItemEditor from "./SubEditors/ItemEditor";
import MainProductEditor from "./SubEditors/MainProductEditor";
import OptionEditor from "./SubEditors/OptionEditor";
import StageEditor from "./SubEditors/StageEditor";
import StageVisualizer from "./Visualizers/StageVisualizer";

type ConfigEditorProps = {
   currentProduct: MainProduct | null | undefined;
   currentStage: Stage | null;
   currentOption: Option | null;
   currentItem: Item | null;
   controlHovered: ControlHover | null;
   setControlHovered: React.Dispatch<React.SetStateAction<ControlHover | null>>;
};

export default function ConfigEditor({
   currentProduct,
   currentStage,
   currentOption,
   currentItem,
   controlHovered,
   setControlHovered,
}: ConfigEditorProps) {
   let currentEditor: JSX.Element;
   if (currentItem) {
      currentEditor = <ItemEditor item={currentItem} />;
   } else if (currentOption) {
      currentEditor = <OptionEditor option={currentOption} />;
   } else if (currentStage) {
      currentEditor = <StageEditor stage={currentStage} />;
   } else if (currentProduct) {
      currentEditor = <MainProductEditor product={currentProduct} />;
   } else {
      currentEditor = (
         <div className="flex items-center justify-center h-full text-gray-500 text-sm">
            Select a product, stage, option, or item to edit
         </div>
      );
   }

   return (
      <div className="flex flex-row w-full ">
         <div>{currentEditor}</div>
         <StageVisualizer
            controlHovered={controlHovered}
            setControlHovered={setControlHovered}
            stage={currentStage}
            productTitle={currentProduct?.title}
         />
      </div>
   );
}

//hi
